import { InfoCircleFilled } from '@ant-design/icons';
import { Popover, Space, Row, Col, Button } from 'antd';
import styles from './DeleteOrganizationPopover.module.less';
import { MemberRecord } from './MembersActionsList';

interface MemberDeletePopoverProps {
    isAdmin: boolean;
    testId?: string;
    record: MemberRecord;
    handleOk: () => void;
    isDeleteVisible: boolean;
    setIsDeleteVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const MemberDeletePopover = ({
    handleOk,
    isDeleteVisible,
    setIsDeleteVisible,
    record,
    testId = 'MemberDeletePopover',
    isAdmin,
}: MemberDeletePopoverProps) => {
    const handleSubmit = () => {
        setIsDeleteVisible(false);
        handleOk();
    };

    const getDeletePopoverMessage = () => {
        if (isAdmin && record.status !== 'Pending') {
            return `Are you sure that you want to remove ${record.user} from organization`;
        }
        if (record.status === 'Pending') {
            return `Are you sure that you want to revoke member's invitation?`;
        }
        if (!isAdmin)
            return `Are you sure that you want to leave organization?`;
    };

    return (
        <Popover
            data-testid={testId}
            open={isDeleteVisible}
            placement="left"
            content={
                <>
                    <Row justify={'end'} className={styles.PopoverContentRow}>
                        <Col span={2}>
                            <InfoCircleFilled
                                className={styles.ExclamationCircleFilledColor}
                            />
                        </Col>
                        <Col span={22}>
                            <div>Are you sure?</div>
                            <div>{getDeletePopoverMessage()}</div>
                        </Col>
                    </Row>

                    <Row justify={'end'} className={styles.PopoverActionsRow}>
                        <Space>
                            <Button
                                type="primary"
                                onClick={() => handleSubmit()}
                            >
                                Yes
                            </Button>
                            <Button onClick={() => setIsDeleteVisible(false)}>
                                No
                            </Button>
                        </Space>
                    </Row>
                </>
            }
            trigger="click"
            onOpenChange={() => setIsDeleteVisible(!isDeleteVisible)}
        ></Popover>
    );
};

export default MemberDeletePopover;
